import React, { useContext } from "react";
import { Grid, Paper } from "@mui/material";
import { AppContext } from "App";

const Details = (props) => {
  const { cstmr, gender, accBalType } = props;
  const { settings } = useContext(AppContext);
  return (
    <Paper className="pt-[5px] bg-white shadow-xs">
      {cstmr ? (
        <Grid
          container
          spacing={3}
          className="p-[15px] text-gray-700 mb-[10px]"
        >
          <Grid item xs={12} md={4} className="grid">
            <span className="text-[11px] tracking-wider uppercase mb-[5px] text-gray-500">
              Customer Id
            </span>
            <span className="text-[16px] font-medium text-gray-500">
              {cstmr.id}
            </span>
          </Grid>
          <Grid item xs={12} md={4} className="grid">
            <span className="text-[11px] tracking-wider uppercase mb-[5px] text-gray-500">
              Customer Code
            </span>
            <span className="text-[16px] font-medium text-gray-500">
              {cstmr.cstmrCode}
            </span>
          </Grid>
          <Grid item xs={12} md={4} className="grid">
            <span className="text-[11px] tracking-wider uppercase mb-[5px] text-gray-500">
              Customer Group
            </span>
            <span className="text-[16px] font-medium text-gray-500">
              {cstmr.cstmrGroup && cstmr.cstmrGroup.name}
            </span>
          </Grid>
          <Grid item xs={12} md={4} className="grid">
            <span className="text-[11px] tracking-wider uppercase mb-[5px] text-gray-500">
              First Name
            </span>
            <span className="text-[16px] font-medium text-gray-500">
              {cstmr.firstName}
            </span>
          </Grid>
          <Grid item xs={12} md={4} className="grid">
            <span className="text-[11px] tracking-wider uppercase mb-[5px] text-gray-500">
              Last Name
            </span>
            <span className="text-[16px] font-medium text-gray-500">
              {" "}
              {cstmr.lastName}
            </span>
          </Grid>
          <Grid item xs={12} md={4} className="grid">
            <span className="text-[11px] tracking-wider uppercase mb-[5px] text-gray-500">
              Gender
            </span>
            <span className="text-[16px] font-medium text-gray-500">
              {" "}
              {gender}
            </span>
          </Grid>
          <Grid item xs={12} md={4} className="grid">
            <span className="text-[11px] tracking-wider uppercase mb-[5px] text-gray-500">
              Phone
            </span>
            <a
              className="link text-[16px] font-medium text-gray-500"
              href={`tel${cstmr.phone}`}
            >
              {cstmr.phone}
            </a>
          </Grid>
          <Grid item xs={12} md={4} className="grid">
            <span className="text-[11px] tracking-wider uppercase mb-[5px] text-gray-500">
              Email
            </span>
            <a
              className="link text-[16px] font-medium text-gray-500"
              href={`mailto${cstmr.email}`}
            >
              {cstmr.email}
            </a>
          </Grid>

          <Grid item xs={12}>
            <div className="flex items-center mt-[20px]">
              <span className="text-gray-500 uppercase font-medium text-[14px] min-w-[70px]">
                Address
              </span>
              <div className="border border-gray-500 w-[100%]" />
            </div>
          </Grid>
          <Grid item xs={12} md={4} className="grid">
            <span className="text-[11px] tracking-wider uppercase mb-[5px] text-gray-500">
              Address Line 1
            </span>
            <span className="text-[16px] font-medium text-gray-500">
              {cstmr.address1}
            </span>
          </Grid>
          <Grid item xs={12} md={4} className="grid">
            <span className="text-[11px] tracking-wider uppercase mb-[5px] text-gray-500">
              Address Line 2
            </span>
            <span className="text-[16px] font-medium text-gray-500">
              {cstmr.address2}
            </span>
          </Grid>
          <Grid item xs={12} md={4} className="grid">
            <span className="text-[11px] tracking-wider uppercase mb-[5px] text-gray-500">
              City
            </span>
            <span className="text-[16px] font-medium text-gray-500">
              {cstmr.city}
            </span>
          </Grid>
          <Grid item xs={12} md={4} className="grid">
            <span className="text-[11px] tracking-wider uppercase mb-[5px] text-gray-500">
              State
            </span>
            <span className="text-[16px] font-medium text-gray-500">
              {cstmr.state}
            </span>
          </Grid>
          <Grid item xs={12} md={4} className="grid">
            <span className="text-[11px] tracking-wider uppercase mb-[5px] text-gray-500">
              ZIP
            </span>
            <span className="text-[16px] font-medium text-gray-500">
              {cstmr.zip}
            </span>
          </Grid>
          <Grid item xs={12}>
            <div className="flex items-center mt-[20px]">
              <span className="text-gray-500 uppercase font-medium text-[14px] min-w-[150px]">
                Additional Details
              </span>
              <div className="border border-gray-500 w-[100%]" />
            </div>
          </Grid>

          <Grid item xs={12} md={4} className="grid">
            <span className="text-[11px] tracking-wider uppercase mb-[5px] text-gray-500">
              Company Name
            </span>
            <span className="text-[16px] font-medium text-gray-500">
              {cstmr.company}
            </span>
          </Grid>
          <Grid item xs={12} md={4} className="grid">
            <span className="text-[11px] tracking-wider uppercase mb-[5px] text-gray-500">
              Date of Birth
            </span>
            <span className="text-[16px] font-medium text-gray-500">
              {cstmr.dob}
            </span>
          </Grid>
          <Grid item xs={12} md={4} className="grid">
            <span className="text-[11px] tracking-wider uppercase mb-[5px] text-gray-500">
              Website
            </span>
            <a
              className="link text-[16px] font-medium text-gray-500"
              href={cstmr.website}
              target="_blank"
              rel="noreferrer"
            >
              {cstmr.website}
            </a>
          </Grid>
          <Grid item xs={12} md={4} className="grid">
            <span className="text-[11px] tracking-wider uppercase mb-[5px] text-gray-500">
              Twitter
            </span>
            <a
              className="link text-[16px] font-medium text-gray-500"
              href={cstmr.twitter}
              target="_blank"
              rel="noreferrer"
            >
              {cstmr.twitter}
            </a>
          </Grid>
          <Grid item xs={12}>
            <div className="flex items-center mt-[20px]">
              <span className="text-gray-500 uppercase font-medium text-[14px] min-w-[80px]">
                Settings
              </span>
              <div className="border border-gray-500 w-[100%]" />
            </div>
          </Grid>
          <Grid item xs={12} md={4} className="grid">
            <span className="text-[11px] tracking-wider uppercase mb-[5px] text-gray-500">
              Allow an on account balance
            </span>
            <span className="text-[16px] font-medium text-gray-500">
              {accBalType}
            </span>
          </Grid>
          <Grid item xs={12} md={4} className="grid">
            <span className="text-[11px] tracking-wider uppercase mb-[5px] text-gray-500">
              Balance Limit
            </span>
            <span className="text-[16px] font-medium text-gray-500">
              {settings?.currSymbol} {cstmr.balLimit}
            </span>
          </Grid>
          <Grid item xs={12} md={4} className="grid">
            <span className="text-[11px] tracking-wider uppercase mb-[5px] text-gray-500">
              Tax
            </span>
            <span className="text-[16px] font-medium text-gray-500">
              {cstmr.tax && cstmr.tax.name}
            </span>
          </Grid>
          <Grid item xs={12}></Grid>
        </Grid>
      ) : (
        "Loading..."
      )}
    </Paper>
  );
};

export default Details;
